module.exports = __webpack_public_path__ + "img/[生病].3280b8bf.svg";